import React, { forwardRef } from 'react';

import CardComponent from '../components/Card';
import { useAppView } from '../hooks/config';

const Card = forwardRef((props, ref) => {

    const appView = useAppView();

    return (
        <CardComponent 
            appView={appView}
            ref={ref}
            {...props}
        />
    );

});

export default Card;
